<avi-continue-confirmation
    [customHeader]="header"
    [warning]="warning"
    (onClose)="handleCancel()"
    (onConfirm)="handleContinue()"
></avi-continue-confirmation>
